import { api } from '@shared/api'
import { toast } from '@shared/lib'
import { useRoute, useRouter } from 'vue-router'
import { ref, computed, watchEffect } from 'vue'

const permissions = ref([])
const pagination = ref({})
const roles = ref([])

export function usePermissions() {
  const route = useRoute()
  const router = useRouter()

  const searchParams = computed(() => ({
    role: route.query.role || undefined,
    fulltext: route.query.fulltext || undefined,
    page: route.query.page ? parseInt(route.query.page) : undefined
  }))

  const updateQuery = (params) => {
    const newQuery = { ...route.query, ...params }
    Object.keys(newQuery).forEach(key => {
      if (newQuery[key] === null || newQuery[key] === undefined || newQuery[key] === '') {
        delete newQuery[key]
      }
    })
    router.replace({ query: newQuery })
  }

  const fetchRoles = async () => {
    try {
      const { data } = await api.get('api/v1/admin/permissions/roles')
      roles.value = data.roles
    } catch {
      toast.error('Не удалось загрузить роли. Попробуйте еще раз!')
    }
  }

  const fetchPermissionsList = async () => {
    try {
      const { data } = await api.get('api/v1/admin/permissions', { params: searchParams.value })
      permissions.value = data.permissions
      pagination.value = data.pagination
    } catch {
      permissions.value = []
      pagination.value = {}
      toast.error('Не удалось загрузить права доступа. Попробуйте еще раз!')
    }
  }

  const searchUsers = async (query) => {
    if (!query) return []
    try {
      const { data } = await api.get('api/v1/admin/users/search', { params: { term: query } })
      return data.map(item => ({ value: item.id, text: item.label }))
    } catch {
      toast.error('Не удалось найти пользователей')
      return []
    }
  }

  const createPermission = async ({ user_id, role, name }) => {
    try {
      await api.post('api/v1/admin/permissions', { permission: { user_id, role } })
      toast.success('Право доступа добавлено!')
    } catch {
      toast.error('Не удалось добавить право доступа!')
      throw new Error()
    }
  }

  const deletePermission = async (id) => {
    try {
      await api.delete(`api/v1/admin/permissions/${id}`)
      toast.success('Право доступа удалено!')
      await fetchPermissionsList()
    } catch {
      toast.error('Не удалось удалить право доступа!')
    }
  }

  watchEffect(() => fetchPermissionsList())
  watchEffect(() => fetchRoles())

  return { roles, permissions, pagination, updateQuery, searchUsers, createPermission, deletePermission, fetchPermissionsList }
}
